// extracted by mini-css-extract-plugin
export default {"footnotelink":"style-module--footnotelink--d774a","cookieButton":"style-module--cookieButton--36c97"};